import { Link, useParams } from 'react-router-dom';
import { readableInk } from '@jobshop/shared';
import { useJob } from '../../api/hooks';
import { Card, CardHeader, ErrorNote, Spinner } from '../../components/ui';
import { JobNav } from './JobNav';
import { ScanHistory } from './ScanHistory';

/**
 * One job's scans, at full length. The Plan page carries the same evidence in a boxed
 * panel beside the plan; this is the page you open when the evidence *is* the question
 * — "did that cabinet ever reach finishing?" — and it is where "Scans" on the jobs list
 * lands.
 */
export function JobScansPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const job = useJob(jobId);

  if (job.isLoading) return <Spinner />;
  if (job.error) return <ErrorNote error={job.error} />;
  if (!job.data) return null;
  const detail = job.data;

  return (
    <div className="space-y-3">
      <Card>
        <CardHeader
          title={
            <span className="flex flex-wrap items-center gap-2">
              <Link to="/jobs" className="text-ink-400 hover:underline">
                Jobs
              </Link>
              <span className="text-ink-300">/</span>
              <span
                className="rounded px-1.5 py-0.5"
                style={{ backgroundColor: detail.color, color: readableInk(detail.color) }}
              >
                {detail.name}
              </span>
              <JobNav
                jobId={detail._id}
                current="scans"
                partsBatchId={detail.batches.length === 1 ? detail.batches[0]!._id : undefined}
              />
            </span>
          }
          subtitle="Every scan on this job, newest first. Absence proves nothing — most parts carry no label."
        />
      </Card>

      <ScanHistory jobId={detail._id} full />
    </div>
  );
}
